module.exports = __webpack_public_path__ + "static/media/bottles.a59d40cd.png";